module.exports = __webpack_public_path__ + "img/ke_pic6.67dda43d.png";